export default function floatToTimeString(timeFloat: number): string {
	const timeStrings = timeFloat.toFixed(2).toString().split('.');
	const minutes = (60 / (100 / parseInt(timeStrings[1]))).toString();

	return `${timeStrings[0].length === 1 ? '0' : ''}${
		timeStrings[0]
	}:${minutes}${minutes.length === 1 ? '0' : ''}`;
}
